import React from 'react'
import { useNavigate } from 'react-router-dom'

const HeroSection: React.FC = () => {
  const navigate = useNavigate()

  return (
    <section
      className="relative text-white"
      style={{ background: 'linear-gradient(150deg, #42419E 30%, #B3B3DF 100%)' }}>
      {/* Navigation */}
      <nav
        className="sticky top-0 px-6 py-6 flex justify-between items-center z-50 shadow-md"
        style={{ backgroundColor: '#2C2B69' }}>
        <div className="container mx-auto flex justify-center md:justify-between items-center">
          <div
            className="flex flex-row gap-2 items-center cursor-pointer"
            onClick={() => navigate('/')}>
            <img className="object-scale-down h-6" src={`/capgains-icon-dark.png`} />
            <div className="text-2xl font-bold">My Cap Gains</div>
          </div>
          <div className="flex gap-4 hidden md:block">
            <button
              onClick={() => navigate('/auth/login')}
              className="px-6 py-2 text-white hover:text-blue-200 transition">
              Login
            </button>
            <button
              onClick={() => navigate('/auth/signup')}
              className="px-6 py-2 bg-white rounded-lg hover:bg-blue-50 transition font-semibold"
              style={{ color: '#42419E' }}>
              Get Started
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="container mx-auto px-6 py-20 md:py-32">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Simplify Your International Investments
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-blue-100 leading-relaxed">
            Simplify your investment reporting across currencies with our professional
            capital gains calculator. Accurate, fast, and easy to use.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/auth/signup')}
              className="px-8 py-4 bg-white rounded-lg hover:bg-blue-50 transition font-semibold text-lg shadow-lg"
              style={{ color: '#42419E' }}>
              Start Calculating Now
            </button>
            <button
              onClick={() =>
                document
                  .getElementById('how-it-works')
                  ?.scrollIntoView({ behavior: 'smooth' })
              }
              className="px-8 py-4 text-white rounded-lg transition font-semibold text-lg border-2 border-white"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)')
              }>
              Learn More
            </button>
          </div>
        </div>
      </div>

      {/* Wave Divider */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z"
            fill="white"
          />
        </svg>
      </div>
    </section>
  )
}

export default HeroSection
